import { render, staticRenderFns } from "./newLayout1.vue?vue&type=template&id=d50663b4&scoped=true&"
import script from "./newLayout1.vue?vue&type=script&lang=js&"
export * from "./newLayout1.vue?vue&type=script&lang=js&"
import style0 from "./newLayout1.vue?vue&type=style&index=0&id=d50663b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50663b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VTooltip})
